import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from '../../spinner-component/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { SessionDataService } from '../service/session-data.service';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged,catchError, map } from 'rxjs/operators';
import { FormGroup, FormBuilder } from '@angular/forms';
@Component({
  selector: 'app-camera-mapping',
  templateUrl: './camera-mapping.component.html',
  styleUrls: ['./camera-mapping.component.css']
,
  standalone: false
})
export class CameraMappingComponent implements OnInit {
  pageTitle: string = 'User Camera Mapping';
  potentialId: any;
  siteName: string[] = [];
  domLayout = '';
  noRowsTemplate: string;
  validationMsg: string = '';
  gridOptions: any;
  recordsList: any;
  hasData: boolean;
  cameras: any;
  popupHeading: string;
  modalRef: NgbModalRef;
  camerasList: any = [];
  @ViewChild('openCamera', { static: false })
  openCameraMapping: ElementRef<any>;
  userName: any;
  selectedCameras: any;
  user: any;
  userEmail: any;
  potentialIdLength: boolean;
  siteNamesIdLength: boolean;
  data: any[] = [];
  selectAllChecked: boolean;
  showTable: boolean = false;

  gridApi: any;
  gridColumnApi: any;

  search!: FormGroup;
  searchValid = true;
  selectedSuggestionDetails: any;
  isShowDropdown: boolean = false;
  SiteNameSuggestions: any[];
  siteDetails: any;

  constructor(public spinner: SpinnerService,
    private toastr: ToastrService,
    public sessionDataService: SessionDataService,
    private ngbModalService: NgbModal,
    private fb: FormBuilder,
    private http: HttpClient) {
    this.domLayout = 'autoHeight';
    this.noRowsTemplate = `<span>No records to show</span>`;
  }
  ngOnInit(): void {
    this.gridOptions = { columnDefs: [], rowData: [] };
    this.search = this.fb.group({
      searchText: ['']
    });
    this.search.get('searchText')!.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(value => {
      if (!value || value.length < 3) {
        this.SiteNameSuggestions = [];
        // this.clearTable();
      } else {
        this.fetchSuggestions(value).subscribe(suggestions => {
          this.SiteNameSuggestions = suggestions;
        });
      }
    });
  }

  // clearTable() {
  //   this.gridOptions = {
  //     columnDefs: [],
  //     rowData: []
  //   };
  //   this.showTable = false;
  //   this.hasData = false;
  // }

  fetchSuggestions(name: string) {
    this.spinner.deactivate();
    return this.sessionDataService.getUsersByAll(name).pipe(
      map((response: any) => {
        const siteArray = response?.data || [];
        return siteArray
          .filter(item => item && item.siteName)
          .map(item => ({
            siteName: item.siteName,
            potentialId: item.potentialId,
            accountName: item.accountName 
          }));
      }),
      catchError(error => {
        return of([]);
      })
    );
  }
  
  onSuggestionClick(sitename:any,event:Event) {
    event.preventDefault();
    this.siteDetails = sitename;
    this.search.get('searchText')?.setValue(sitename.siteName, { emitEvent: false });
    this.isShowDropdown = false;
    this.SiteNameSuggestions = [];
  }

  performSearch() {
    const query = (this.search.value.searchText || '').toString().trim();
    if (!query) {
      this.potentialIdLength = false;
      this.validationMsg = 'Please enter Potential Id';
      this.toastr.error('Please enter site name, account name or Potential ID', 'Error');
      return;
    }

    const potentialId = this.resolvePotentialId(query);
    if (!potentialId) {
      this.potentialIdLength = false;
      this.validationMsg = 'Please enter Potential Id';
      this.toastr.error('Please select a site from suggestions or enter a valid Potential ID', 'Error');
      return;
    }

    this.getUsersByPotentialId(String(potentialId));
  }

  /** Resolve potentialId from selected suggestion, matching suggestion list, or typed numeric ID. */
  private resolvePotentialId(query: string): string | number | null {
    if (this.siteDetails?.potentialId != null && this.siteDetails.potentialId !== '') {
      const selectedName = (this.siteDetails.siteName || '').toString().trim();
      // Keep selected site only when search text still matches that selection
      if (!selectedName || selectedName === query || String(this.siteDetails.potentialId) === query) {
        return this.siteDetails.potentialId;
      }
    }

    const match = this.SiteNameSuggestions?.find(
      (s) =>
        String(s?.potentialId) === query ||
        (s?.siteName || '').toString().trim().toLowerCase() === query.toLowerCase()
    );
    if (match?.potentialId != null && match.potentialId !== '') {
      this.siteDetails = match;
      return match.potentialId;
    }

    // Allow direct Potential ID entry (digits)
    if (/^\d+$/.test(query)) {
      this.siteDetails = { ...(this.siteDetails || {}), potentialId: query, siteName: query };
      return query;
    }

    return null;
  }
  
  getUsersByPotentialId(potentialId: string) {
    if (potentialId == null || potentialId === '') {
      this.potentialIdLength = false;
      this.validationMsg = 'Please enter Potential Id';
      return;
    }

    this.potentialIdLength = true;
    this.spinner.activate();
    this.recordsList = [];
    this.sessionDataService.getUsersByPotentialId(potentialId).subscribe(
      (response: any) => {
        const hasData = response && (response.status == 200 || response.success === true) && response.data;
        if (hasData) {
              this.hasData = true;
              this.showTable = true;
              let recList = response.data;
              let index = 0;
              if (recList.users && recList.users.length > 0) {
                recList.users.forEach((userName) => {
                  index++;
                  this.userName = userName.user;
                  if(userName.cameras === null || userName.cameras.length === 0){
                  this.selectAllChecked = true;
                  this.cameras = 'All Cameras';
                  }
                  else{
                    this.selectAllChecked = false;
                    this.cameras = userName.cameras.toString();
                    let removeCharacters = this.cameras.replace(/[\[\]"]/g, '');
                    let cameraString = removeCharacters.substring(0, 12);
                    if (removeCharacters.length > 12) {
                      cameraString += '...';
                    }
                    this.cameras = cameraString;
                  }
                  let obj: any = {
                    id: index,
                    siteName: recList.siteName,
                    userName: userName.user,
                    cameras: this.cameras,
                  };
                  this.recordsList.push(obj);
                });
              }
              this.gridOptions = {
                defaultColDef: {
                  resizable: true,
                  sortable: true,
                  filter: true,
                  headerClass: 'headerClass',
                },
                paginationPageSize: 30,
                columnDefs: [
                  {
                    headerName: '#',
                    field: 'id',
                    width: 200,
                    suppressSizeToFit: true,
                  },
                  {
                    headerName: 'Site Name',
                    field: 'siteName',
                    width: 300,
                    suppressSizeToFit: true,
                  },
                  {
                    headerName: 'User Name',
                    field: 'userName',
                    width: 300,
                    suppressSizeToFit: true,
                  },
                  {
                    headerName: 'Cameras',
                    field: 'cameras',
                    width: 200,
                    suppressSizeToFit: true,
                    onCellClicked: this.assignCameras.bind(this),
                    cellStyle: (params) =>
                      params.value == 'All Cameras' || this.cameras
                        ? { 'text-decoration': 'underline', cursor: 'pointer' }
                        : null
                  }
                ],
                rowData: this.recordsList,
              };
            } else {
              this.hasData = false;
              this.showTable = true;
              this.gridOptions = {
                domLayout: 'autoHeight',
                noRowsTemplate: `<span>No records to show</span>`,
                columnDefs: [],
                rowData: [],
              };
            }
            this.spinner.deactivate();
          },
          (err) => {
            this.spinner.deactivate();
            this.hasData = false;
            this.showTable = false;
            this.toastr.error('Unexpected Error Occured', 'Error');
          }
        );
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    if (this.gridApi && this.recordsList) {
      this.gridApi.setRowData(this.recordsList);
    }
    params.api.sizeColumnsToFit();
  }

  assignCameras(params: any) {
    const rowData = params.data;
    this.userName = rowData.userName;
    if (params.value === "All Cameras") {
      this.selectAllChecked = true;
    }
    else {
      this.selectAllChecked = false;
    }
    this.getCameras();
    this.popupHeading = 'Assign Cameras to User';
    this.camerasList.forEach((element) => {
      element.checked = false;
    });
    this.modalRef = this.ngbModalService.open(this.openCameraMapping);
  }

  getCameras() {
    this.spinner.activate();
    this.camerasList = [];
    const url = `${environment.restrictUserDomain}/usercammapping/getallcameras?`;
    this.sessionDataService
      .restrictUser(
        url +
        'potentialId=' +
        this.siteDetails.potentialId + '&username=' + this.userName
      )
      .subscribe(
        (response) => {
          let cameraList = response.data;
          if (cameraList.length > 0) {
            cameraList.forEach((cameras) => {
              let obj = {
                id: cameras.cameraId,
                name: cameras.name,
                uniqueid: cameras.camerauniqueid,
                checked: cameras.checked,
              };
              this.camerasList.push(obj);
              let allChecked = this.camerasList.every(camera => camera.checked);
              this.selectAllChecked = allChecked;
              this.spinner.deactivate();
            });
          }
        },
        (err) => {
          this.spinner.deactivate();
          this.ngbModalService.dismissAll();
          this.toastr.error('Unable to show Camera list at the moment', 'Error');
        }
      );
    this.spinner.deactivate();
  }

  saveCameraMapping() {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.userEmail = this.user.email;
    const selectedCameras = this.camerasList.filter((camera) => camera.checked);
    this.selectedCameras = selectedCameras?.map((camera) => camera.name).join(', ');
    const selectedCameraUniqueIds = selectedCameras.map(
      (camera) => camera.uniqueid
    );
    let model = {
      potentialId: this.siteDetails.potentialId ,
      cameraUinqueIdList: selectedCameraUniqueIds,
      username: this.userName,
      modifiedBy: this.userEmail,
    };
    this.spinner.activate();
    const url = `${environment.restrictUserDomain}/usercammapping/save`;
    this.sessionDataService
      .saveRestrictUser(url, model)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.toastr.success('Cameras updated successfully', 'Success');
            this.ngbModalService.dismissAll();
            this.recordsList.forEach((record) => {
              let removeCharacters = this.selectedCameras.replace(/[\[\]"]/g, '');
              let cameraString = removeCharacters.substring(0, 12);
              if (removeCharacters.length > 12) {
                cameraString += '...';
              }
              this.selectedCameras = cameraString;
              if (record.userName === this.userName) {
                record.cameras = this.selectedCameras;
                if (this.selectedCameras === "") {
                  record.cameras = "All Cameras"
                }
                else {
                  localStorage.setItem('recordList', JSON.stringify(this.recordsList));
                }
              }

            });
            if (this.gridApi) {
              this.gridApi.setRowData(this.recordsList);
            }
            this.spinner.deactivate();
          }
        },
        (err) => {
          this.spinner.deactivate();
          this.toastr.error('Unexpected Error Occured', 'Error');
        }
      );
  }

  selectAll() {
    this.camerasList.forEach(camera => camera.checked = this.selectAllChecked);
    this.updateSelectAllChecked();
  }

  updateSelectAllChecked() {
    this.selectAllChecked = this.camerasList.every(camera => camera.checked);
  }

  closePopUp() {
    this.selectAllChecked = false;
  }

}




